<template>
    <v-card style="width: 100%; min-width: 500px; min-height: 260px; padding: 20px; overflow: hidden;">
        <span>Ajouter une carte bancaire</span>

        <v-divider></v-divider>
        <div v-if="this.resultContainer" class="alert alert-info" role="alert">{{ this.resultContainer }}</div>

        <v-progress-circular indeterminate color="primary" class="text-center" v-if="stripLoading" style="width: 100%;">
        </v-progress-circular>
        <v-list v-show="!stripLoading">
            <v-list-item>
                <div style="width: 100%">
                    <v-form>
                        <v-text-field
                            single-line
                            dense
                            label="Nom du titulaire du compte"
                            v-model="cardholderName"
                            maxlength="30"
                        ></v-text-field>
                        <div id="card-element" class="my-2" style="border-bottom: 1px solid #b4b4b4;padding: 14px 0;"></div>
                    </v-form>
                </div>
            </v-list-item>
        </v-list>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="close()">
                Fermer
            </v-btn>
            <v-btn
                color="primary"
                text
                @click="handlePaymentMethod"
                :disabled="stripLoading || !complete"
                :loading="this.loading"
            >
                Ajouter
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js/pure'
//const stripe = await loadStripe(process.env.MIX_STRIPE_PUBLISHABLE_KEY);
    

// const stripe = await loadStripe(
//     'pk_test_51HmllBD3yNnMveD5dEsmI8KvzO29aTPd48t7pZWR9yxmH2fpEGdQhbJ49qfA9K1eSv8GOmCJUJbeJnNithkhBgXp00A2TbKxZa'
// )

export default {
    props: ['userId', 'userName'],
    name: 'AddNewPaymentCard',
    data() {
        return {
            config:{},
            stripe: null,
            cardElement: null,
            cardholderName: null,
            resultContainer: 'Waiting stripe to load ...',
            loading: false,
            stripLoading: true,
            complete: true,
        }
    },
    methods: {
        async init() {
            console.log('init stripe ... ')
            this.stripe = await loadStripe(this.config.api_publishable_key)
            const elements = this.stripe.elements()
            this.cardElement = elements.create('card')
            this.cardElement.mount('#card-element')

            this.cardElement.on('ready', () => {
                this.stripLoading = false
                this.resultContainer = null
            })
        },
        async addClientCard(token) {
            this.loading = true
            await axios
                .post(
                    `/back-office/customer/${this.userId}/payment/updatePaymentMethod`,
                    {
                        token: token,
                    },
                    { withCredentials: true }
                )
                .then(() => {
                    console.log('res.success')
                    this.resultContainer = 'La carte a été ajoutée avec succès.'

                    this.$emit('add-new-card')
                    this.loading = false
                    //  window.location.reload()
                })
                .catch(res => {
                    console.log('res.error', res)
                    this.resultContainer = res.message
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async handlePaymentMethod() {
            this.resultContainer = null
            this.loading = true

            const { paymentMethod, error } = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.cardElement,
                billing_details: {
                    name: this.cardholderName,
                },
            })

            if (error) {
                // Display error.message in your UI.
                this.resultContainer = error.message
            } else {
                // You have successfully created a new PaymentMethod
                this.resultContainert = 'Created payment method: ' + paymentMethod.id
                console.log('succuess', paymentMethod.id)
                this.addClientCard(paymentMethod.id)
            }
        },
        close() {
            this.cardholderName = ''
            this.cardElement.clear()
            this.$emit('close-modal')
        },
    },
    watch: {},
    async mounted() {
        const response = await axios.get('/api/config');
        this.config = response.data;
        // console.log('App Name:', this.config.api_publishable_key);
        // console.log('Logggg', process.env.STRIPE_PUBLISHABLE_KEY);
        this.init().then(() => {
            console.log('Comp loaded')
        })
    },
}
</script>

<style>
.credit-card-inputs.complete {
    border: 2px solid green;
}
</style>
